"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var FirstTimePointOut =
/*#__PURE__*/
function (_Component) {
  _inherits(FirstTimePointOut, _Component);

  function FirstTimePointOut() {
    var _this;

    _classCallCheck(this, FirstTimePointOut);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FirstTimePointOut).call(this));
    _this.state = {
      show: true
    };
    _this.onCloseClick = _this.onCloseClick.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(FirstTimePointOut, [{
    key: "render",
    value: function render() {
      var show = this.state.show;
      var _this$props = this.props,
          headerId = _this$props.headerId,
          ftpRef = _this$props.ftpRef,
          children = _this$props.children,
          noArrow = _this$props.noArrow,
          dismissText = _this$props.dismissText;

      if (!show) {
        return null;
      }

      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])('dqpl-pointer-wrap', {
          'dqpl-no-arrow': noArrow
        }),
        role: "region",
        "aria-labelledby": headerId
      }, noArrow ? null : _react["default"].createElement("div", {
        className: "dqpl-arrow"
      }, _react["default"].createElement("div", {
        className: "dqpl-arrow-pointer"
      }), _react["default"].createElement("div", {
        className: "dqpl-arrow-neck"
      })), _react["default"].createElement("div", {
        className: "dqpl-box"
      }, _react["default"].createElement("button", {
        className: "dqpl-ftp-dismiss fa fa-close",
        type: "button",
        "aria-label": dismissText,
        onClick: this.onCloseClick
      }), _react["default"].createElement("div", {
        className: "dqpl-content",
        tabIndex: "-1",
        ref: ftpRef
      }, children)));
    }
  }, {
    key: "onCloseClick",
    value: function onCloseClick() {
      this.setState({
        show: false
      });
      this.props.onClose();
    }
  }]);

  return FirstTimePointOut;
}(_react.Component);

exports["default"] = FirstTimePointOut;

_defineProperty(FirstTimePointOut, "propTypes", {
  headerId: _propTypes["default"].string.isRequired,
  children: _propTypes["default"].node.isRequired,
  ftpRef: _propTypes["default"].func,
  noArrow: _propTypes["default"].bool,
  onClose: _propTypes["default"].func,
  dismissText: _propTypes["default"].string
});

_defineProperty(FirstTimePointOut, "defaultProps", {
  ftpRef: function ftpRef() {},
  noArrow: false,
  onClose: function onClose() {},
  dismissText: 'dismiss'
});

FirstTimePointOut.defaultProps = {
  onClose: function onClose() {}
};